import { useState } from "react";
import { HTTP_STATUSES } from "@miplatform/constants";
import { createUUID } from "@miplatform/utils";
import { useComponentState } from "../useComponentState/useComponentState";

const getAssignmentTemplatesUUID = createUUID();

export const useAssignmentTemplate = ({ service }) => {
  const [assignmentTemplates, setAssignmentTemplates] = useState([]);
  const stateManager = useComponentState();

  const getAssignmentTemplates = () => {
    stateManager.abort(getAssignmentTemplatesUUID);
    stateManager.run(async () => {
      const response = await service.assignmentTemplates.getAll({
        sort: "name asc",
      });

      if (response.status === HTTP_STATUSES.OK) {
        setAssignmentTemplates(
          response.data.map(({ id, name }) => ({ label: name, value: id }))
        );
      }
    }, getAssignmentTemplatesUUID);
  };

  return {
    loading: stateManager.isBusy(),
    assignmentTemplates,
    getAssignmentTemplates,
  };
};
